export class BrandWords extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.updateTransform = this.updateTransform.bind(this)

    window.addEventListener('scroll', this.updateTransform)
    window.addEventListener('resize', this.updateTransform)
    this.updateTransform()
  }

  updateTransform () {
    const sectionMargin = 30
    const viewportHeight = window.innerHeight
    const viewportCenter = viewportHeight / 2

    const isMobile = !window.BAO.MediaBreakpoints.isSm

    const sectionRect = this.getBoundingClientRect()
    const sectionCenter = sectionRect.top + sectionRect.height / 2

    const distanceFromCenter =
      (sectionCenter - viewportCenter) / (viewportHeight / 2)

    this.els.word.elements.forEach((word) => {
      const direction = word.dataset.direction || 'none'
      if (direction === 'none') return

      const directionMultiplier = direction === 'end' ? 1 : -1

      const wordSize = isMobile
        ? word.getBoundingClientRect().width
        : word.getBoundingClientRect().height

      const sectionSize =
        sectionRect[isMobile ? 'width' : 'height'] - sectionMargin

      const maxMovement = (sectionSize - wordSize) / 2

      let offset = maxMovement * distanceFromCenter * directionMultiplier

      offset = Math.max(-maxMovement, Math.min(maxMovement, offset))

      if (direction === 'start') {
        offset = Math.min(0, offset)
      } else if (direction === 'end') {
        offset = Math.max(0, offset)
      }

      const transformProperty = isMobile ? 'translateX' : 'translateY'
      word.style.transform = `${transformProperty}(${offset}px)`
    })
  }
}

if (!customElements.get('brand-words')) {
  customElements.define('brand-words', BrandWords)
}
